/// <reference types="@angular/localize" />

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, {
  // `eventCoalescing` collapses the several change-detection runs that a single user
  // interaction can schedule into one — noticeable on the form-heavy pages (the
  // assignment stepper renders an exercises editor per session).
  applicationProviders: [provideZoneChangeDetection({ eventCoalescing: true })],
})
  .catch(err => console.error(err));
